<template>
    <el-tree
        ref="moduleTree"
        :data="list"
        show-checkbox
        node-key="id"
        :default-expanded-keys="expanded_keys"
        :default-checked-keys="checked_keys"
        default-expand-all
        :props="defaultProps"
        @check="handleCheck"
        @node-click="nodeClick"
        v-loading="loading"
    >
    </el-tree>
</template>
<script>
export default {
    data() {
        return {
            loading: false,
            list: [],
            checked_nodes: [],
            checked_keys: [],
            expanded_keys: [],
            defaultProps: {
                children: 'children',
                label: 'name'
            }
        };
    },
    
    props:{
        params:{
            type:Array,
            required:false
        }
    },

    created(){
        this.list = this.params;
        this.checked_nodes = this.collectItems(this.list);
        this.checked_keys = this.checked_nodes.map(item => item.id);
        this.$emit('handleSubmitModuleBind', this.checked_nodes);
    },
   
    methods:{
        nodeClick(data, node, ojb){
            // bus.$emit('search', data);
            console.log('nodeClick:', data, node, ojb);
        },
        handleCheck(data, obj){
            this.$emit('handleSubmitModuleBind', obj.checkedNodes);
        },

        //递归函数来收集 is_show 为 true 的 id
        collectItems(items) {
            let list = [];
            for (let i = 0; i < items.length; i++) {
                if (items[i].is_show) {
                    list.push(items[i]);
                }
                if (items[i].children && items[i].children.length > 0) {
                    // 递归调用收集子级
                    list = list.concat(this.collectItems(items[i].children));
                }
            }
            return list;
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/views/order/jiaoben/moduleBindXb3.vue